module.exports = __webpack_public_path__ + "a0b48b04bd12947eacce25db1ffff5c8.svg";